import { openExternalLinkModal } from "components/ExternalLinkModal";
import { mapValues, tokenize } from "data/utils";
import { fetchForm } from "data/api";

/**
 * opens the specified url either in a modal popup or new browser window
 * @param {{ asModal?: boolean}} { asModal } whether to open as Modal within inPoint
 * @param {{ docked?: boolean}} { docked } whether to open as a Docked Modal (only with asModal=true)
 * @param {{ url: string }} { url } supports interpolation with any context properties
 * @param {{ title?: string }} { title } Modal or Browser window title
 * @param {{ specs?: string }} { specs } Browser window(..., specs) specifications
 * @param {{ useFormTokens?: boolean }} { useFormTokens } whether to load all Form fields/attributes for the tokens
 */

type Context = {
    asModal?: boolean,
    docked?: boolean,
    url: string,
    title?: string,
    specs?: string,
    useFormTokens?: boolean,
    context: ?Object,
};

class link {
    execute = async ({
        asModal,
        docked,
        url,
        title,
        specs,
        useFormTokens,
        ...context
    }: Context): Promise<boolean> => {
        // in this case ALL context props are URL encoded
        let encodedContext = mapValues(context, (value) =>
            encodeURIComponent(value)
        );

        try {
            if (useFormTokens === true) {
                const form = await fetchForm(context.itemUri);
                let rawValues = {};
                if (form.fields && form.fields.length > 0) {
                    form.fields.forEach(
                        (field) =>
                            (rawValues["ip_" + field.name] = encodeURIComponent(
                                field.value
                            ))
                    );
                }

                if (form.attributes && form.attributes.length > 0) {
                    form.attributes.forEach(
                        (attribute) =>
                            (rawValues["ea_" + attribute.name] =
                                encodeURIComponent(attribute.value))
                    );
                }
                encodedContext = Object.assign(encodedContext, rawValues);
            }
        } catch (e) {
            console.error("Error while useFormTokens", e);
            alert("Sorry an error has occurred while fetching form; Aborting.");
            return false;
        }
        const tokenizedUrl = tokenize(
            url.replace("{ea.", "{ea_").replace("{ip.", "{ip_"), // hack since tokenize does not support sub-objects
            encodedContext
        );
        if (asModal === true) {
            openExternalLinkModal({ url: tokenizedUrl, name: title, docked });
        } else {
            window.open(
                tokenizedUrl,
                title || "",
                specs || "" // "width=600px,height=640px"
                //"scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=100,top=100"
            );
        }
        return true;
    };
}
export default link;
